import * as React from 'react';

import { ColumnWidthsContext } from '../../../utils/contexts';

/**
 * Hook to calculate the cumulative left position of a column by summing widths of all previous columns, as we use this more frequently to offset UI over columns.
 */
export function useColumnOffset({
    columnId,
    columnOrder,
}: {
    columnId: string;
    columnOrder: string[];
}) {
    // Get column widths from context
    const columnWidths = React.useContext(ColumnWidthsContext);

    // Calculate cumulative position by summing widths of all previous columns
    const cumulativeLeftPosition = React.useMemo(() => {
        let position = 0;
        const columnIndex = columnOrder.indexOf(columnId);

        // If column not found in order, just return 0
        if (columnIndex === -1) return 0;

        // Sum widths of all columns up to but NOT including this one
        for (let i = 0; i < columnIndex; i++) {
            const colId = columnOrder[i];
            const width = columnWidths.get(colId) ?? 0;
            position += width;
        }

        return position;
    }, [columnId, columnOrder, columnWidths]);

    return cumulativeLeftPosition;
}
